export default "__VITE_ASSET__PhAWgFsv__"